import { gql } from '@apollo/client';

export const getUniversities = (
  allUniversities: University[],
  countries?: Country[],
  faculties?: string[],
  keyword?: string
): University[] => {
  let filtered = allUniversities;
  if (countries && countries.length > 0) {
    filtered = filtered.filter((university) =>
      countries.find((country) => country.title === university.country)
    );
  }
  if (faculties && faculties.length > 0) {
    filtered = filtered.filter((university) =>
      faculties.find((faculty) => faculty === university.faculty)
    );
  }
  if (keyword) {
    filtered = filtered.filter((university) =>
      university.title?.match(new RegExp(keyword, 'ig'))
    );
  }
  filtered = filtered.sort((a, b) => a.country.localeCompare(b.country));
  return filtered;
};

export const getActivityName = (name: string): string => {
  return activityMap[name];
};

export const getTimetableName = (name: string): string => {
  return timetableMap[name];
};

const activityMap: { [index: string]: string } = {
  exchange: 'Exchange program',
  research: 'Research /Joint Research',
  publication: 'Publication',
  double: 'Double Degree',
  joint: 'Joint Degree',
  articulation: 'Articulation',
  cotutelle: 'Cotutelle',
  shortCourse: 'Short Course Training',
  internship: 'Student Internship',
  residency: 'Residency / Fellowship',
  shortTerm: 'Short term',
  longTerm: 'Long term',
  teaching: 'Teaching',
  researcher: 'Researcher',
  supporting: 'Supporting',
  conference: 'Conference /Seminar/Symposia',
  others: 'Others',
};

const timetableMap: { [index: string]: string } = {
  semester1: 'Semester 1',
  semester2: 'Semester 2',
  trimester1: 'Trimester 1',
  trimester2: 'Trimester 2',
  trimester3: 'Trimester 3',
  summer: 'Summer term',
  winter: 'Winter term',
  fall: 'Fall or Autumn term',
  spring: 'Spring term',
  etc: 'Etc.',
};

export const deserialize = (data: any): University => {
  return {
    region: data.region,
    country: data.country,
    title: data.title,
    faculty: data.faculty,
    period: data.period,
    program: data.program,
    email: data.email,
    website: data.website,
    file: data.file,
    activity: {
      exchange: data.exchange,
      research: data.research,
      publication: data.publication,
      double: data.double,
      joint: data.joint,
      articulation: data.articulation,
      cotutelle: data.cotutelle,
      shortCourse: data.shortCourse,
      internship: data.internship,
      residency: data.residency,
      shortTerm: data.shortTerm,
      longTerm: data.longTerm,
      teaching: data.teaching,
      researcher: data.researcher,
      supporting: data.supporting,
      conference: data.conference,
      others: data.others,
    },
    timetable: {
      semester1: data.semester1,
      semester2: data.semester2,
      trimester1: data.trimester1,
      trimester2: data.trimester2,
      trimester3: data.trimester3,
      summer: data.summer,
      winter: data.winter,
      fall: data.fall,
      spring: data.spring,
      etc: data.etc,
    },
    fee: data.fee,
  };
};

export const QUERY = gql`
  query findUniversities($first: Int) {
    universities(first: $first, order: country_ASC) {
      edges {
        node {
          region
          country
          title
          faculty
          program
          detail
          fee
          email
          website
          file
          exchange
          research
          publication
          double
          joint
          articulation
          cotutelle
          shortCourse
          internship
          residency
          shortTerm
          longTerm
          teaching
          researcher
          supporting
          conference
          others
          semester1
          semester2
          trimester1
          trimester2
          trimester3
          summer
          winter
          fall
          spring
          etc
        }
      }
    }
  }
`;
